import { HttpClient } from "@/adapters";
import environment from "@/enviroments/enviroment";

class ConversationService {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }

  setChannelId(channelId) {
    this.channelId = channelId;
  }

  message(message, conversation_id = null, options = {}) {
    const buffer = {
      message,
      ...options,
    };

    if (conversation_id !== null) {
      Object.assign(buffer, { conversation_id });
    }

    const body = JSON.stringify(buffer);
    const headers = {};

    if (this.channelId) {
      headers["x-genia-channel-id"] = this.channelId;
    }

    const sseClient = this.httpClient.sse("", {
      method: "POST",
      body,
      headers,
    });

    return sseClient;
  }

  async feedback(conversation_id, message_id, params, headers = {}) {
    const finalHeaders = { ...headers };

    if (this.channelId) {
      finalHeaders["x-genia-channel-id"] = this.channelId;
    }

    const response = await this.httpClient.post(
      "/feedback",
      {
        conversation_id,
        message_id,
        ...params,
      },
      finalHeaders,
    );

    return response;
  }
}

const baseUrl = `${environment.API_URL}/conversation`;
const conversationService = new ConversationService(new HttpClient(baseUrl));

export default conversationService;
